<template>
  <v-dialog v-model="openDialog"
            lazy
            @input="v => v"
            :full-width="!$vuetify.breakpoint.smAndDown"
            max-width="500">
    <v-card class="pa-4">
      <v-layout column>

        <v-text-field v-model="nickname"
                      data-vv-as="Nickname"
                      data-vv-name="nickname"
                      data-vv-scope="modal"
                      v-validate="`required`"
                      label="Nickname">
        </v-text-field>

        <v-card-actions>
          <v-spacer />
          <v-btn color="accent"
                 :loading="loadingBtn"
                 :disabled="errors.any('modal')"
                 @click="save()">
            Save
          </v-btn>
          <v-btn color="accent" flat
                 @click="openDialog = false">
            Cancel
          </v-btn>
        </v-card-actions>
      </v-layout>
    </v-card>
  </v-dialog>
</template>

<script>
import API from '@/api';

export default {
  name: 'EditNicknameDialog',
  props: {
    value: {
      type: Boolean,
    },
    load: {
      type: Object,
    },
  },
  data() {
    return {
      nickname: null,
      loadingBtn: false,
      openDialog: this.value,
    };
  },
  watch: {
    value() {
      this.openDialog = this.value;
      this.nickname = this.load.nickname;
      if (!this.value) {
        this.resetForm();
      }
    },
    openDialog() {
      this.$emit('input', this.openDialog);
    },
  },
  methods: {
    async save() {
      try {
        this.loadingBtn = true;
        const apiResponse = await API.company.saveRepeatLoad({
          loadId: this.load.humanId,
          body: {
            nickname: this.nickname,
          },
        });

        this.openDialog = false;
        this.$emit('refresh', apiResponse.data);
      } catch (e) {
        console.error(e);
      } finally {
        this.loadingBtn = false;
      }
    },
    resetForm() {
      this.nickname = null;
    },
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/EditNicknameDialog.vue